import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentCmsUrls } from '@core/domain/types/environment-config.types';
import { ConfigService } from '@core/services/config/config.service';
import {
    ConfigRequired,
    RequestParam,
    RequestParams,
} from '@core/services/http-requests/http-requests.service';
import { TranslationService } from '@core/services/translation.service';
import { CmsResponse } from '@features/cms-render/domain/models/cmsResponse';

@Injectable()
export class ApiCmsRenderService {
    constructor(
        private readonly http: HttpClient,
        private readonly configService: ConfigService,
    ) {
    }

    // TODO ECOMDUTI-20989 METODO DUPLICADO cms-render.service.ts
    public setRequestParams(isVip, date?): RequestParam[] {
        let requestParams: RequestParam[] = [];
        if (isVip) requestParams.push({ key: 'userFlags', value: 'vip' });
        if (!!date) requestParams.push({ key: 'timeTravelTo', value: date });
        return requestParams;
    }

    public getPage(slug: string, country: string, lang: string, customParams?: RequestParams): Observable<CmsResponse> {
        const language = TranslationService.fixLangCode(lang);

        const url = this.requestCms(`${slug}`, country, language, customParams);
        return this.http.get<CmsResponse>(url);
    }

    @ConfigRequired<ApiCmsRenderService, Error>(new Error('Configuration not found'))
    // eslint-disable-next-line @typescript-eslint/default-param-last
    public requestCms(slug: string | null = null, country: string, lang: string, params?: RequestParams): string {
        const paramsString: string = params ? '&' + params.map((i) => `${encodeURIComponent(i.key)}=${i.value}`).join('&') : '';
        const baseUrl = this.configService.getConfigUrl<EnvironmentCmsUrls>('cmsUrls').api;
        return `${baseUrl}/materialized/page/${slug}?country=${country}&lang=${lang}${paramsString}`;
    }

    @ConfigRequired<ApiCmsRenderService, Error>(new Error('Configuration not found'))
    public requestPreviewCms(previewUrl: string): string {
        const baseUrl = this.configService.getConfigUrl<EnvironmentCmsUrls>('cmsUrls').materialized;
        return `${baseUrl}/materialized/page/${previewUrl}`;
    }
}
